import { jsx as k } from "react/jsx-runtime";
import { DiscIcon as s } from "../DiscIcon/DiscIcon.js";
import { Ui as f } from "../Ui/Ui.js";
function n({
  symbol: t,
  size: r,
  className: e,
  ...a
}) {
  const { assetsBaseUrl: o } = f.useUi(), c = `${o}/token-icons/fallback.svg`, i = t ? `${o}/token-icons/${t.toLowerCase()}.svg` : c;
  return /* @__PURE__ */ k(
    s,
    {
      alt: t,
      className: e,
      fallback: c,
      size: r,
      src: i,
      title: t,
      ...a
    }
  );
}
((t) => {
  t.Stack = s.Stack;
})(n || (n = {}));
export {
  n as TokenIcon
};
//# sourceMappingURL=TokenIcon.js.map
